<div class="category" [ngClass]="{ removeBorderBottom: isLastOfPage }">
  <div
    class="video-play-count-row"
    [style]="{ marginBottom: isMobile ? '8px' : '16px' }"
  >
    <div class="video-play-count">
      <img
        class="video-play-count-img"
        src="assets/icons/video-play-count.svg"
        alt="Play"
      />
      <span class="video-play-count-text">{{ totalCount }} Vídeos</span>
    </div>
    <a
      *ngIf="isMobile"
      [routerLink]="['categoria/conteudos', category.id]"
      [queryParams]="{ categoryName: category.nome }"
      queryParamsHandling="merge"
      class="see-all-videos-button"
    >
      Ver Todos <i class="bi bi-arrow-right-short see-all-videos-arrow"></i>
    </a>
  </div>

  <div class="listing-header">
    <h1 class="listing-title">
      {{ category.nome }}
    </h1>
    <a
      *ngIf="!isMobile"
      [routerLink]="['categoria/conteudos', category.id]"
      [queryParams]="{ categoryName: category.nome }"
      queryParamsHandling="merge"
      class="see-all-videos-button"
    >
      Ver Todos <i class="bi bi-arrow-right-short see-all-videos-arrow"></i>
    </a>
  </div>

  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="videos.length > 0; else noVideoContent">
      <app-swiper-component
        [videos]="videos"
        [index]="index"
      ></app-swiper-component>
    </ng-container>
  </ng-container>
</div>

<ng-template #loading>
  <div class="loading-videos">
    <div class="loading-wrapper">
      <app-generic-loading [isLoading]="true"></app-generic-loading>
    </div>
  </div>
</ng-template>

<ng-template #noVideoContent>
  <div class="no-video-content">
    <span class="no-video-content-text"
      >No momento não há vídeos disponíveis nesta categoria.</span
    >
  </div>
</ng-template>
